import { DATE_FORMATS } from "../../../../constants";

export function parseToCheckDuplicationModel(
  academicId,
  stepValues,
  allIntakes,
  programId?,
) {
  const parsedData = {} as any;

  parsedData.academicId = academicId;
  parsedData.programType = +stepValues.programType;
  parsedData.branches = stepValues.branches.map((branch) => ({
    branchId: branch,
  }));

  parsedData.intakes = allIntakes.map((intake) => ({
    startDate: intake.startDate.format(DATE_FORMATS.frontEnd),
    deadline: intake.deadline.format(DATE_FORMATS.frontEnd),
  }));

  if (programId) {
    parsedData.id = programId;
  }

  if (stepValues.major) {
    parsedData.majorId = stepValues.major.id;
  }

  if (stepValues.housingTypes?.length) {
    parsedData.housingTypes = [...stepValues.housingTypes];
  }

  return parsedData;
}
